function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";
import classnames from "classnames";
import SignupButton from "segments/desktop/core-components/button/signup-button/signup-button";
import AnimatedTag from "./animated-tag/animated-tag-component";
import { MAX_TAG_WIDTH } from "./animated-tag/animated-tag-constants";
import { StyledSelectableTagsGridButtonComponent } from "./selectable-tags-grid-button-component.scss";
import SecondaryButton from "segments/desktop/core-components/button/secondary-button/secondary-button";
import YouTubePopUpButton from "../../button/youtube-popup-button/youtube-popup-button";
const SelectableTagsGridButtonComponent = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { buttonConfig, beforeRedirectSyncAction, secondaryButtonConfig, youTubeButtonConfig, skipSignupUpdateCluster, shouldSendClustersAsParams, displayedOnDarkTheme, style, websiteAlignmentBranding, disableAnimation } = props;
    const [animatedTags, setAnimatedTags] = useState([]);
    const [tagStartingPosition, setTagStartingPosition] = useState({});
    const [shakeButton, setShakeButton] = useState(false);
    const [paintButtonColor, setPaintButtonColor] = useState(null);
    const buttonContainerRef = useRef();
    const updateStartingPosition = ()=>{
        requestAnimationFrame(()=>{
            var _buttonContainerRef_current;
            //  we want to put it in the center of the button, it's dynamic width so need to calculate it
            const buttonToCalculateFor = (_buttonContainerRef_current = buttonContainerRef.current) === null || _buttonContainerRef_current === void 0 ? void 0 : _buttonContainerRef_current.querySelector("button");
            if (!buttonToCalculateFor) return;
            const boundClientRect = buttonToCalculateFor.getBoundingClientRect();
            const startingPositionFromLeft = boundClientRect.left + (boundClientRect.width / 2 - MAX_TAG_WIDTH / 2);
            setTagStartingPosition({
                left: startingPositionFromLeft
            });
        });
    };
    const onTagAnimationEndCallback = useCallback((tagIndex)=>{
        const filtered = animatedTags.filter((t)=>{
            return t.tagIndex !== tagIndex;
        });
        setAnimatedTags([
            ...filtered
        ]);
        if (disableAnimation) return;
        if (shakeButton) {
            setShakeButton(false);
            setTimeout(()=>{
                setShakeButton(true);
            }, 0);
        } else {
            setShakeButton(true);
        }
    }, [
        disableAnimation,
        shakeButton
    ]);
    const renderSelectionAnimationIfNeeded = ()=>{
        if (!(tagStartingPosition === null || tagStartingPosition === void 0 ? void 0 : tagStartingPosition.left)) return null;
        return animatedTags.map((tagToAnimate)=>{
            return /*#__PURE__*/ _jsx(AnimatedTag, {
                tagToAnimate: tagToAnimate,
                tagStartingPosition: tagStartingPosition,
                onAnimationEndCallback: onTagAnimationEndCallback
            }, tagToAnimate.tagIndex);
        });
    };
    useEffect(()=>{
        if (!websiteAlignmentBranding) {
            updateStartingPosition();
            window.addEventListener("resize", updateStartingPosition, {
                passive: true
            });
            return ()=>{
                window.removeEventListener("resize", updateStartingPosition, {
                    passive: true
                });
            };
        }
    }, []);
    useImperativeHandle(ref, ()=>({
            clickedTag: (gridSelectableTag, isSelected)=>{
                if (!isSelected) return;
                if (websiteAlignmentBranding) {
                    setPaintButtonColor(gridSelectableTag.tagBackgroundColor);
                    !disableAnimation && setShakeButton(true);
                } else {
                    //  adding new and removing current if already there
                    setAnimatedTags([
                        gridSelectableTag,
                        ...animatedTags.filter((t)=>{
                            return t.tagIndex !== gridSelectableTag.tagIndex;
                        })
                    ]);
                }
            }
        }), [
        animatedTags,
        disableAnimation
    ]);
    return /*#__PURE__*/ _jsxs(StyledSelectableTagsGridButtonComponent, {
        className: "selectable-tags-button-container",
        ref: buttonContainerRef,
        style: style,
        children: [
            !websiteAlignmentBranding && renderSelectionAnimationIfNeeded(),
            /*#__PURE__*/ _jsx("div", {
                className: classnames("button-wrapper", {
                    "shake-button": shakeButton
                }),
                onAnimationEnd: ()=>!disableAnimation && shakeButton && setShakeButton(false),
                children: /*#__PURE__*/ _jsx(SignupButton, _object_spread_props(_object_spread({}, buttonConfig), {
                    shouldSendClustersAsParams: shouldSendClustersAsParams,
                    beforeSubmitCallback: beforeRedirectSyncAction,
                    skipUpdateCluster: skipSignupUpdateCluster,
                    displayedOnDarkTheme: displayedOnDarkTheme,
                    paintButtonColor: paintButtonColor
                }))
            }),
            secondaryButtonConfig && /*#__PURE__*/ _jsx("div", {
                className: "secondary-button-wrapper",
                children: /*#__PURE__*/ _jsx(SecondaryButton, _object_spread({}, secondaryButtonConfig))
            }),
            youTubeButtonConfig && /*#__PURE__*/ _jsx("div", {
                className: "youtube-button-wrapper",
                children: /*#__PURE__*/ _jsx(YouTubePopUpButton, _object_spread({}, youTubeButtonConfig))
            })
        ]
    });
});
export default SelectableTagsGridButtonComponent;
